var icon = require('vue-svgicon')
icon.register({
  'ks-icon-assignment': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M60 63.61a6.45 6.45 0 0 1 6.43-5.93H79a21 21 0 1 0-19 5.93zM60 74.6c-21.33 1-38 10-38 20.9V106h38z"/><g><path pid="1" d="M75.65 72.79h8.04v8.04h-8.04zM75.65 91.54h8.04v8.04h-8.04z"/><path pid="2" d="M107.81 62.06h-11.2a8 8 0 0 0-15.12 0h-11.2a5.36 5.36 0 0 0-5.36 5.36v37.52a5.36 5.36 0 0 0 5.36 5.36h37.52a5.36 5.36 0 0 0 5.36-5.36V67.42a5.36 5.36 0 0 0-5.36-5.36zm-21.44 40.2H73v-13.4h13.4zm0-18.76H73V70.11h13.4zm2.68-16.08a2.68 2.68 0 1 1 2.68-2.68 2.68 2.68 0 0 1-2.68 2.68zm16.07 30.82H91.73v-5.36h13.39zm0-18.76H91.73v-5.36h13.39z"/></g>'
  }
})
